"use client";
const createValidHtmlId = (str) => str.replaceAll(/[^A-Za-z0-9_-]/g, "");
export {
  createValidHtmlId
};
